import { useState } from "react";
//import { useNavigate } from "react-router-dom";
export default function MenuSection() {
  const [index, setIndex] = useState(0);
  //const navigate = useNavigate();

  const handleReservation = () => {
    window.open("https://resy.com/cities/edison-nj/venues/house-of-bombay");
  };
  const images = ["/chai_bar_11.png", "/chai_bar_22.png"];

  const prevSlide = () => {
    setIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="cb-menu-section" id="chaibarmenu">
      <div className="hero-border-menu">
        <div className="cb-menu-container">
          <div className="inner-menu-container">
            <h2 className="menu-title">The Chai Bar (Coming Soon)</h2>

            <p className="menu-text">In Bombay, chai is never just tea. </p>

            <p className="menu-text">
              It’s a daily rhythm, a pause between moments, a reason to stand
              still and talk. Shared on street corners, in cafés, outside
              offices, and inside homes, chai shapes the city’s pace as much as
              its people do. Our Chai Bar honours this ritual, from cutting chai
              and Irani-style brews to spiced and contemporary expressions. Each
              cup reflects a different mood of the city, offering warmth,
              familiarity, and quiet connection. 
            </p>

            <p className="menu-text">
              This is how Bombay slows down, even when it never stops
            </p>

            {/* <button className="menu-btn">BOOK A TABLE</button> */}
            {/* <p className="par-menu-btn">
              <button className="menu-btn" onClick={() => handleReservation()}>
                BOOK A TABLE
              </button>
            </p> */}
          </div>
          {/* <div className="cb-menu-carousel-bg">
            
            <button className="arrow left" onClick={prevSlide}>
              <span>‹</span>
            </button>

            <div className="cb-menu-images">
              {images.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt="menu"
                  className={i === index ? "active" : ""}
                />
              ))}
            </div>

            <button className="arrow right" onClick={nextSlide}>
              <span>›</span>
            </button>
          </div> */}
        </div>
      </div>
    </section>
  );
}
